<template>
  <div class="header-site-supervision">
    <strong>現場監督：</strong>
    <span v-html="text"></span>
  </div>
</template>
<script>
export default {
  data () {
    return {
      text: '',
      timer: null
    }
  },
  created () {
    this.gettextdata()
    this.timer = setInterval(() => {
      this.gettextdata()
    }, 10000)
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  methods: {
    async gettextdata () {
      try {
        const res = await this.$axios.uptpodds()
        this.text = res.map(it => `${it.betplace}-${it.oddsname} ${it.newvalue}`).join(', ')
      } catch (error) {
        console.error(error)
      }

    }
  }
};
</script>
<style lang="scss">
.header-site-supervision {
  margin-top: 2px;
  width: 70%;
  min-width: 1000px;
  height: 20px;
  line-height: 20px;
  border-radius: 5px;
  border: solid 1px $header-site-supervision-borderColor;
  background-color: $header-site-supervision-bg;
  color: $header-site-supervision-color;
  padding: 0 12px;
  font-size: 12px;
}
</style>
//J-特码12 45.995